import { Col, Empty, Row, Skeleton, Space, Spin, Table, Typography } from "antd";
import { useEffect, useState } from "react";
// import { useRecoilState } from "recoil";
import { Currency } from "../../util/Currency";
import { prettifyPaperSize, getPrintCartSizeLabel, prettifyPaperType, getPaginationTitle } from "../../../util/utils";
// import { memberState } from "../../../state/atoms";
import "../PrintCheckoutPage";
import moment from "moment";
import OrdersApi from "../../../api/OrdersApi";
import { ItemThumbsPreview } from "./ItemThumbsPreview";

const { Paragraph } = Typography;

const locale = {
  emptyText: (
    <Empty
      image={Empty.PRESENTED_IMAGE_SIMPLE}
      imageStyle={{ height: 60 }}
      description={<span> No data yet to show</span>}
    />
  ),
};

export function Summary({ order, setOrder, isComputingTax, isMobile, loadingExpectedDeliveryDate, setLoadingExpectedDeliveryDate, checkoutMessage }: any) {
  const [loading] = useState(false);
  // const [loadingExpectedDeliveryDate, setLoadingExpectedDeliveryDate] = useState(false);
  const [expectedDeliveryDate, setExpectedDeliveryDate] = useState('');

  // const [member] = useRecoilState(memberState);

  useEffect(() => {
    // setExpectedDeliveryDate(order.edd)
    if (order.edd) {
      if (order.edd === "conflict") {
        setExpectedDeliveryDate("conflict");
      } else {
        console.log('Processing EDD:', {
          rawEdd: order.edd,
          type: typeof order.edd
        });
        
        // Remove ordinals and parse directly with moment
        const dateWithoutOrdinal = order.edd.replace(/(\d)(st|nd|rd|th)/, '$1');
        
        console.log('After processing:', {
          dateWithoutOrdinal,
          attemptedParse: dateWithoutOrdinal
        });
        
        // Parse the date string directly with moment
        let start = moment(dateWithoutOrdinal, 'dddd, MMMM D, YYYY');
        let startLabel = '';

        if (start.isoWeekday() === 6) startLabel = start.add(2, "days").format('dddd, MMMM Do');
        else if (start.isoWeekday() === 7) startLabel = start.add(1, "days").format('dddd, MMMM Do');
        else startLabel = start.format('dddd, MMMM Do');

        // Clone the start date for end date calculation instead of parsing the formatted string
        let end = moment(start).add(2, 'days');
        let endLabel = '';

        if (end.isoWeekday() === 6) endLabel = end.add(2, "days").format('dddd, MMMM Do');
        else if (end.isoWeekday() === 7) endLabel = end.add(1, "days").format('dddd, MMMM Do');
        else endLabel = end.format('dddd, MMMM Do');

        let eddText = startLabel + " and " + endLabel;
        setExpectedDeliveryDate(eddText)
      }
    } else if (order && order.state && order.zip) {
      if (setLoadingExpectedDeliveryDate) setLoadingExpectedDeliveryDate(true);

      if (!loadingExpectedDeliveryDate) {
        OrdersApi.getExpectedDeliveryDate(order.id).then(resp => {
          // setExpectedDeliveryDate(resp.data);
          if (setLoadingExpectedDeliveryDate) setLoadingExpectedDeliveryDate(false);

          if (resp.data) {
            if (resp.data === "conflict") {
              order.edd = "conflict";
              if (setOrder) setOrder(order);
            } else {
              // const eddDebug = JSON.parse(resp.data.debug)
              // console.log("-> EDD Debug:")
              // console.log(eddDebug)

              order.edd = moment(resp.data.edd, 'YYYYMMDD').format('dddd, MMMM Do, YYYY');
              if (setOrder) setOrder(order);
            }
          }
        })
      }
    } else {
      setExpectedDeliveryDate('');
    }

  }, [order, loadingExpectedDeliveryDate, setLoadingExpectedDeliveryDate, setOrder]);

  return (
    <div className={"summary"}>
      {loading && <Skeleton />}

      {!isMobile && <h3>Order Summary</h3>}
      {isMobile && <h5>Review Your Order</h5>}

      {!loading && order && (
        <>
          <Table
            locale={locale}
            loading={loading}
            showHeader={false}
            rowKey="id"
            columns={[
              {
                title: "Product",
                dataIndex: "designName",
                key: "designName",
                align: "left",
                render: (designName, item) => (
                  <>
                    <Row>
                      <Col span={8}>
                        <div className="des-thumb">
                          <ItemThumbsPreview item={item} />
                          {/* <Image
                            alt={item.designName}
                            loading="eager"
                            src={`${env.rendererPath}/design/thumbnail/${item.designId}?height=300`}
                            preview={{ src: `${env.rendererPath}/design/thumbnail/${item.designId}?height=600` }}
                            placeholder={<LoadingOutlined style={{ fontSize: 40, color: '#bbb', marginTop: 40 }} />}
                            style={{ maxWidth: '100%' }}
                          /> */}
                        </div>
                      </Col>

                      <Col span={16}>
                        <Space direction="vertical">
                          <div className="design-name"><strong>{designName}</strong></div>
                          <Paragraph className={"design-info"}>
                            {prettifyPaperSize(item.paperSize)} {getPrintCartSizeLabel(item.designSize)} - {item.pages} {item.pages === 1 ? 'page' : 'pages'}
                            <br />
                            <span className={"cap"}>{prettifyPaperType(item.paperType, item)}</span>
                            <br />
                            {getPaginationTitle(item.pagination)}
                            <br />
                            {item.quantity} Copies
                            <br />
                            {item.designSize.indexOf('gift-certificate') > -1 && <span>Starting Number {item.gcStartingNumber}</span>}
                            <br />
                            <div className="price"><Currency>{item.price}</Currency></div>
                          </Paragraph>
                        </Space>
                      </Col>
                    </Row>
                  </>
                ),
              }
            ]}
            dataSource={order.items}
            pagination={false}
          />

          <Row className="totals">
            <Col span={24}>
              {order.discount ?
                <Row justify="space-between">
                  <Col>Discount:</Col>
                  <Col>{isComputingTax ? <Spin size="small" /> : <>- <Currency>{order.discount}</Currency></>}</Col>
                </Row> : ''
              }

              <Row justify="space-between">
                <Col>Subtotal:</Col>
                <Col><Currency>{order.subtotal}</Currency></Col>
              </Row>

              {order.state && order.zip ?
                <Row justify="space-between">
                  <Col>Shipping &amp; Processing:</Col>
                  <Col><Currency>{order.shipping}</Currency></Col>
                </Row>
                : ''
              }

              <Row justify="space-between">
                <Col>Tax:</Col>
                <Col>{isComputingTax ? <Spin size="small" /> : <Currency>{order.tax}</Currency>}</Col>
              </Row>

              <Row justify="space-between" className="total">
                <Col>Total:</Col>
                <Col>{isComputingTax ? <Spin size="small" /> : <Currency>{order.total}</Currency>}</Col>
              </Row>
            </Col>
          </Row>

          {((expectedDeliveryDate || loadingExpectedDeliveryDate) && expectedDeliveryDate.indexOf('conflict') === -1) ?
            <Row className="expected-delivery" align="middle">
              <Col span={24}>
                <h4>Expected Delivery between</h4>
                <h4 className="date">{loadingExpectedDeliveryDate ? <Spin size="small" /> : expectedDeliveryDate}</h4>
                <Paragraph>
                  {
                    checkoutMessage
                      ? <div dangerouslySetInnerHTML={{ __html: checkoutMessage }} />
                      : <>
                        Please note: the expected delivery date is an<br />
                        estimate and can vary depending on the carrier.
                      </>
                  }
                </Paragraph>
              </Col>
            </Row> : ''}
        </>
      )}
    </div>
  );
}
